<template>
  <div class="myForm">
    <el-form class="search" ref="formRef" :model="formModel" :rules="formRules" :disabled="disabled" :show-message="true" label-suffix="：" :label-position="labelPosition">
      <el-row :gutter="21" style="flex-wrap: wrap;" type="flex" v-if="formData.length">
        <el-col :key="index" :lg="item.colLg ||colLg" :md="24" :sm="24" v-for="(item, index) in formData">
          <el-form-item :label="item.label" :label-width="item.labelWidth || labelWidth" :prop="item.key||''" v-if="item.isShow??true"  :rules="item.rules">
            <!-- 标题 -->
            <div v-if="item.type == 'subtitle'" class="subtitle">
              <div class="text">{{ item.text }}</div>
              <div class="line" :style="{background:item.lineColor||'#d1d5dc'}"></div>
              <!-- <div class="subtitleRight">
                <span>新增</span>
                <img src="@/assets/images/slhgl/icon/add.png" alt="">
              </div> -->
            </div>
            <!-- 文本 -->
            <div v-if="item.type == 'text'">{{ formModel[item.key] }}</div>
            <!-- 输入框 -->
            <el-input v-model="formModel[item.key]"
              :placeholder="'请输入' + (item.placeholder ? item.placeholder : item.label)" clearable
              v-if="item.type == 'input'"
              @change="(e)=>item.change && item.change(e,formData,formModel)"
              :disabled="item.disabled"
            ></el-input>

            <!-- 输入框数字类型 -->
            <el-input v-model.number="formModel[item.key]" :maxlength="16"
              :placeholder="'请输入' + (item.placeholder ? item.placeholder : item.label)" clearable
              v-if="item.type == 'diyInputNumber'">
              <template v-if="item.slotSuffixIcon">
                <i slot="suffix" :class="item.slotPrefixIcon"></i>
              </template>
              <template v-else-if="item.slotSuffixText">
                <span slot="suffix">{{ item.slotSuffixText }}</span>
              </template>
              <template v-if="item.slotPrefixIcon">
                <i slot="prefix" :class="[item.slotPrefixIcon]"></i>
              </template>
              <template  v-else-if="item.slotPrefixText">
                <span slot="prefix">{{ item.slotPrefixText }}</span>
              </template>
             
            </el-input>

            <!-- 计数器 -->
            <el-input-number 
              v-if="item.type == 'inputNumber'"
              v-model="formModel[item.key]" 
              :controls="item.controls??true"
              :controls-position="item.controlsPosition" 
              :min="item.min" :max="item.max"
              style="width:100%"
            >
            </el-input-number>

                <!-- 文本域 -->
            <el-input v-model="formModel[item.key]" type="textarea" :rows="item.rows||5" :maxlength="item.maxlength||500" show-word-limit
              :placeholder="'请输入' + (item.placeholder ? item.placeholder : item.label)" clearable
              v-if="item.type == 'textarea'" :disabled="item.disabled"
            ></el-input>

            <!-- 下拉框 -->
            <el-select v-model="formModel[item.key]" :placeholder="'请选择' + item.label" :disabled="item.disabled" clearable style="width:100%"
              v-if="item.type == 'select'" @change="(e)=>item.change && item.change(e,formData,formModel)"
              :filterable="item.filterable" :remote="item.remote" :remote-method="(e)=>item.remoteMethod && item.remoteMethod(e,formData,formModel)"
            >
              <el-option v-for="(ele, idx) in item.data" :key="idx"
                :label="(item.optionLabel ? ele[item.optionLabel] : ele.dictLabel)"
                :value="item.optionValue ? ele[item.optionValue] : ele.dictValue">
              </el-option>
            </el-select>

            <!-- 级联选择器 -->
            <el-cascader
              v-if="item.type == 'cascader' && item.data"
              v-model="formModel[item.key]"
              :placeholder="'请选择' + item.label" :disabled="item.disabled" clearable style="width:100%"
              :options="item.data ||[]"
              :props="item.props"
              :ref="item.key"
              :key="item.key"
              :show-all-levels="item.showAllLevels??true"
              @change="(e)=>item.change && item.change(e,formData,formModel,$refs[item.key])"
            ></el-cascader>

            <!-- 日期范围选择器 -->
            <el-date-picker
              v-if="item.type == 'daterange'"
              type="daterange"
              v-model="formModel[item.key]"
              end-placeholder="结束日期" :range-separator="item.rangeSeparator||'至'" start-placeholder="开始日期"
              style="width: 100%;"
              :value-format="item.format || 'yyyy-MM-dd'"
              >
            </el-date-picker>

            <!-- 日期时间范围选择器 -->
            <el-date-picker
              v-if="item.type == 'datetimerange'"
              type="datetimerange"
              v-model="formModel[item.key]"
              end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期"
              style="width: 100%;"
              :value-format="item.format || 'yyyy-MM-dd HH:mm:ss'"
              >
            </el-date-picker>

            <!-- 日期和时间点选择器 -->
            <el-date-picker
              v-if="item.type == 'datetime'"
              type="datetime"
              v-model="formModel[item.key]"
              placeholder="选择日期时间"
              style="width: 100%;"
              :value-format="item.format || 'yyyy-MM-dd HH:mm:ss'"
            ></el-date-picker>

            <!-- 选择日 -->
            <el-date-picker
              v-if="item.type == 'date'" type="date"
              v-model="formModel[item.key]"
              placeholder="选择日期"
              style="width: 100%;"
              :value-format="item.format || 'yyyy-MM-dd'"
              >
            </el-date-picker>


            <!-- 年选择器 -->
            <el-date-picker
              v-if="item.type == 'year'"
              type="year"
              v-model="formModel[item.key]"
              placeholder="选择年"
              style="width: 100%;"
              :value-format="item.format || 'yyyy'"
              >
            </el-date-picker>

            <!-- 月选择器 -->
            <el-date-picker
              v-if="item.type == 'month'"
              type="month"
              v-model="formModel[item.key]"
              placeholder="选择月"
              style="width: 100%;"
              :value-format="item.format || 'yyyy-MM'"
              >
            </el-date-picker>

            <!--   插槽   -->
            <slot v-if="item.type === 'slot'" :item="item" :name="item.key" :formModel="formModel" :formData="formData"></slot>

          </el-form-item>

        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    labelWidth: {
      type: String,
      default: '100px',
    },
    disabled:{
      type:Boolean,
      default:false,
    },
    labelPosition: {
      type: String,
      default: 'right',
    },
    colLg: {
      type: [String, Number],
      default: 24
    },
    formData: {
      type: Array,
      default: () => []
    },
    // formModel: {
    //   type: Object,
    //   default: () => { }
    // },
    formRules: {
      type: Object,
      default: () => {}
    },
    //请求接口
    queryFn: {
      type: Function,
      // required: true,
    },
  },
  data() {
    return {
      formModel:{},
    }
  },
  created() {
    this.initFormModel();// 初始化 formModel
  },
  watch:{
    formData:{
      handler(){
        this.initFormModel();// 初始化 formModel
      },
      deep:true,
    }
  },
  methods: {
    // 初始化 formModel
    initFormModel(){
      this.formModel = this.$options.data.call(this).formModel;
      this.formData.forEach(item=>{
        if((item.type == 'diydiyInputNumber' || item.type == 'inputNumber') && item.keyValue){
          item.keyValue = +item.keyValue;
        }
        this.$set(this.formModel,[item.key],item.keyValue??'');
      })
    },
    // 提交数据
    handleSubmit() {
      this.$refs.formRef.validate(valid=>{
        if (valid) {
          // 添加提交的字段
          this.$emit('recombinationFormData', this.formModel, (newParam) => {
            if (newParam !== undefined) this.formModel = newParam
          })
          if (this.queryFn) {
            this.queryFn(this.formModel).then(res => {
              if (res && res.code == 200 && res.data) {
                this.$emit('successChange',res.data,this.formModel)
              }
            }).catch(err => {
              console.log('请求出错', err)
            })
          }else{
            this.$emit('successChange',this.formModel)
          }
        } else {
          this.$message.warning('请检查填写信息！')
          setTimeout(() => {
            document.getElementsByClassName('is-error')[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 0)
        }
      })
    },
    // 重置form表单数据和校验
    resetForm() {
      this.$refs.formRef.resetFields();
    }

  },
}
</script>

<style lang="scss" scoped>
 .subtitle{
    display: flex;
    align-items: center;
    color: #0c7bf2;
    font-weight: bold;
    font-size: 14px;
    .text{
      line-height: 15px;
      padding-left: 8px;
      margin-right: 24px;
      border-left: 2px solid #0C7BF2;
    }
    .line{
      flex: 1;
      height: 1px;
      background: #d1d5dc;
    }
    .subtitleRight{
      cursor: pointer;
      margin-left: 16px;
      display: flex;
      align-items: center;
      >span{
        margin-right: 2px;
      }
      >img{
        width: 24px;
        height: 24px;
      }
    }
  }
</style>
